import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'app-news-card',
    templateUrl: './news-card.component.html',
    styleUrls: ['./news-card.component.scss'],
})
export class NewsCardComponent implements OnInit {
    @Input() image: string = 'https://via.placeholder.com/300x200'; // Placeholder para quando não tiver imagem
    @Input() title: string;
    @Input() link: string;
    @Input() date: string;
    @Input() summary: string;
    @Input() avatar: string;

    /**
     * type ─ Define estilo do card
     * @type {string} 'oblique' | 'simple'
     * @default 'oblique'
     */
    @Input() type: string = 'oblique';
    constructor() {}

    ngOnInit(): void {}

    @HostBinding('class.squared') get isSquared() {
        return this.type === 'squared';
    }
}
